import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { IJNativeEvent } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { IToolbarButton, ToolbarButton, ToolbarButtonPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ToolbarButton";
import { ThemePickerDialog } from "../Dialogs/ThemePickerDialog";
import { NAMESPACE } from "./_Namespace";

export type ThemePickerToolbarButtonPropertyValues =
    ToolbarButtonPropertyValues
    & {
    };

export type ThemePickerToolbarButtonProperties = {
    [name in keyof ThemePickerToolbarButtonPropertyValues]: Property<ThemePickerToolbarButtonPropertyValues[name]>
};

export interface IThemePickerToolbarButton extends IToolbarButton, ThemePickerToolbarButtonProperties
{
}

export class ThemePickerToolbarButton extends ToolbarButton implements IThemePickerToolbarButton
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ThemePickerToolbarButton";
    public static override className = "ThemePickerToolbarButton";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ThemePickerToolbarButtonPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected themeDialog?: ThemePickerDialog;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ThemePickerToolbarButtonPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-toolbar-button-theme-picker");
    }

    // #endregion

    // #region Overrides

    protected override onClick(evt: IJNativeEvent)
    {
        evt.preventDefault();
        evt.stopPropagation();

        if (!this.themeDialog)
            this.themeDialog = new ThemePickerDialog();

        this.themeDialog.openAsync();
    }

    // #endregion

    // #endregion
}

